import { render, staticRenderFns } from "./PaymentInfo.vue?vue&type=template&id=11726e4a&scoped=true"
import script from "./PaymentInfo.vue?vue&type=script&lang=js"
export * from "./PaymentInfo.vue?vue&type=script&lang=js"
import style0 from "./PaymentInfo.vue?vue&type=style&index=0&id=11726e4a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11726e4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11726e4a')) {
      api.createRecord('11726e4a', component.options)
    } else {
      api.reload('11726e4a', component.options)
    }
    module.hot.accept("./PaymentInfo.vue?vue&type=template&id=11726e4a&scoped=true", function () {
      api.rerender('11726e4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/jornalPayment/components/details/PaymentInfo.vue"
export default component.exports